const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (email: string): boolean => {
  const trimmedEmail = email.trim();
  return EMAIL_REGEX.test(trimmedEmail);
};

export const isEmailEmpty = (email: string): boolean => {
  return email.trim().length === 0;
};
